export const PORTAL_PERKS = {
  patient: [
    "Расписание и записи",
    "Абонементы и оплаты",
    "PWA-кабинет на телефоне",
  ],
  staff: [
    "Журнал и расписание",
    "Группы и клиенты",
    "Работа с мобильного",
  ],
  admin: [
    "Финансы и аналитика",
    "Залы и абонементы",
    "Команда клуба",
  ],
};

export function portalEyebrow(clinicName, portalId) {
  if (clinicName) return `Клуб «${clinicName}»`;
  if (portalId === "staff") return "Кабинет тренера";
  if (portalId === "admin") return "Управление клубом";
  return "Личный кабинет клиента";
}
